/**
 * Utility function to get the next sequential service name
 * @param baseName - Base name for the service (e.g., 'zcp', 'zcde', 'adminer')
 * @param existingNames - Array of existing service names to check against
 * @returns Next available service name with appropriate number suffix
 */
export function getNextServiceName(baseName: string, existingNames: string[]): string {
  const baseNameRegex = new RegExp(`^${baseName}(\\d+)?$`);
  
  const existingNumbers = existingNames
    .map((name) => {
      const match = name.match(baseNameRegex);
      if (!match) return -1;
      return match[1] ? parseInt(match[1], 10) : 0;
    })
    .filter((num) => num >= 0);
  
  if (existingNumbers.length === 0) {
    return baseName;
  }
  
  const maxNumber = Math.max(...existingNumbers);
  return maxNumber === 0 ? `${baseName}1` : `${baseName}${maxNumber + 1}`;
}